import { Component, OnInit } from "@angular/core";
import { Location } from "@angular/common";
import { Router } from "@angular/router";
import { getAdverseMediaCategoryLabel } from "../utils/adverse-media-utils";

@Component({
  selector: "app-result-adverse-media-category",
  templateUrl: "./result-adverse-media-category.component.html",
  styleUrls: ["./result-adverse-media-category.component.scss"],
})
export class ResultAdverseMediaCategoryComponent implements OnInit {
  adverseMediaData: any;
  searchedName = "";
  categoryKey = "";
  categoryLabel = "";
  articles: any[] = [];

  constructor(private location: Location, private router: Router) {}

  ngOnInit(): void {
    this.searchedName = localStorage.getItem("adverseMediaSearchedName") || "";
    this.categoryKey = localStorage.getItem("adverseMediaCategory") || "";
    this.categoryLabel = getAdverseMediaCategoryLabel(this.categoryKey);

    const stored = localStorage.getItem("adverseMediaData");
    this.adverseMediaData = stored ? JSON.parse(stored) : null;

    if (this.adverseMediaData && this.categoryKey) {
      const exposure =
        this.adverseMediaData.news_exposures?.[this.categoryKey];
      this.articles = exposure?.articles || [];
    }
  }

  goBack() {
    this.location.back();
  }

  showArticleDetails(article: any) {
    localStorage.setItem("adverseMediaArticle", JSON.stringify(article));
    this.router.navigate(["/result-adverse-media-article"]);
  }
}
